'use strict';

const processInclude = require('base/util');

$(() => {
    processInclude(require('./search/search'));
    processInclude(require('./search/compare'));
    // processInclude(require('base/product/quickView'));
});
